import classNames from 'classnames';
import { Checkbox } from 'shared/ui/Checkbox';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { IconWithTooltip } from 'shared/ui/Tooltip';

interface AcceptLeadsProps {
  isDisabled: boolean;
  isChecked: boolean;
}

export function AcceptOtherServices({ isDisabled, isChecked }: AcceptLeadsProps) {
  return (
    <div className={classNames(isDisabled && 'text-slate-400 pointer-events-none', 'flex pb-3 pl-4 text-sm')}>
      <label className="cursor-pointer">
        <div className="flex items-center">
          <Checkbox
            isDisabled={isDisabled}
            isChecked={isChecked}
            name="acceptOtherServices"
            {...getDataAutoTestAttributes(['checkbox-accept-leads-from-other-services'])}
          />
          Accept leads from other services
        </div>
      </label>
      <IconWithTooltip
        className="relative bottom-[2px] pl-1"
        place="top-start"
        tooltip={
          <div className="max-w-[260px] text-left text-slate-700">
            This campaign will receive leads from external services.
          </div>
        }
        icon="info"
        iconClassNames="text-base text-slate-400 cursor-pointer hover:text-deep-blue-500"
      />
    </div>
  );
}
